export default (that) => [
  {
    type: 'checkbox',
    width: 46,
    fixed: 'left',
    align: 'center',
  },
  {
    type: 'seq',
    title: '#',
    width: 46,
    fixed: 'left',
    align: 'center',
  },
  {
    field: 'editContainerNo',
    title: that.$l('table_label_editContainerNo') || '编辑柜号',
    minWidth: 120,
    align: 'center',
    showHeaderOverflow: true,
  },
  {
    field: 'containerName',
    title: that.$l('table_label_containerName') || '箱型',
    width: 100,
    align: 'center',
    showHeaderOverflow: true,
  },
  {
    field: 'containerGoodsQty',
    title: that.$l('table_label_goodsPieceQty') || '件数',
    width: 80,
    align: 'center',
    showHeaderOverflow: true,
  },
  {
    field: 'containerBoxQty',
    title: that.$l('table_label_ctnQty') || '箱数',
    width: 80,
    align: 'center',
    showHeaderOverflow: true,
  },
  {
    field: 'containerVolume',
    title: that.$l('table_label_volume') || '体积(m³)',
    width: 100,
    align: 'center',
    showHeaderOverflow: true,
  },
  {
    field: 'containerBookingVolume',
    title: that.$l('table_label_bookingVolume') || '订舱体积(m³)',
    width: 110,
    align: 'center',
    showHeaderOverflow: true,
  },
  {
    field: 'totalWeight',
    title: that.$l('table_label_totalWeightKg') || '总重(kg)',
    width: 90,
    align: 'center',
    showHeaderOverflow: true,
  },
]
